module.exports = __webpack_public_path__ + "img/settings.674d9d35.svg";